import { render, staticRenderFns } from "./OrdersCalendarOrderResumeServices.vue?vue&type=template&id=26bd8238&scoped=true&"
import script from "./OrdersCalendarOrderResumeServices.vue?vue&type=script&lang=js&"
export * from "./OrdersCalendarOrderResumeServices.vue?vue&type=script&lang=js&"
import style0 from "./OrdersCalendarOrderResumeServices.vue?vue&type=style&index=0&id=26bd8238&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26bd8238",
  null
  
)

export default component.exports